"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.restEventEmitter = void 0;
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.listeners = new Map();
    }
    EventEmitter.prototype.emit = function (eventName) {
        var restParams = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            restParams[_i - 1] = arguments[_i];
        }
        var events = this.listeners.get(eventName);
        if (events) {
            events.forEach(function (fn) {
                fn.call.apply(fn, __spreadArray([null], restParams, false));
            });
        }
    };
    EventEmitter.prototype.on = function (eventName, fn) {
        if (!this.listeners.get(eventName)) {
            this.listeners.set(eventName, new Set());
        }
        var events = this.listeners.get(eventName);
        events.add(fn);
        // or use unsubscribe function
        return this.off.bind(this, eventName, fn);
    };
    EventEmitter.prototype.once = function (eventName, fn) {
        var unsubscribe = this.on(eventName, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            fn.apply(null, args);
            unsubscribe();
        });
        return unsubscribe;
    };
    EventEmitter.prototype.off = function (eventName, fn) {
        var events = this.listeners.get(eventName);
        if (events)
            events.delete(fn);
    };
    return EventEmitter;
}());
exports.restEventEmitter = new EventEmitter();
//# sourceMappingURL=event_emitter.js.map